import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
export function Blog() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-753">
      <Navbar data-id="element-754" />
      <main className="flex-1" data-id="element-755">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-756">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-757">
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-758">
              Care Nomad Blog
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-759">
              Insights, updates, and stories from the frontlines of healthcare
              staffing in Canada.
            </p>
          </div>
        </section>
        <div className="max-w-3xl mx-auto px-4 py-16 text-center text-text-muted" data-id="element-760">
          <p className="text-xl" data-id="element-761">
            Coming soon! We're working on bringing you the best healthcare
            staffing content.
          </p>
        </div>
      </main>
      <StickyFooter data-id="element-762" />
    </div>;
}